<template>
  <el-dialog
    title="属性配置"
    :visible.sync="visible"
    width="800px"
    append-to-body
    @closed="handleClosed">
    <el-tabs
      v-model="activeTab"
      tab-position="left">
      <el-tab-pane
        label="商品"
        name="product">
        <category-props
          ref="product"
          type="product"
          name="商品"
          :classId="current.classId"
          :templateType="1"
          :base="list.productBaseTemplate"
          :extra="list.productExtraTemplate"></category-props>
      </el-tab-pane>
      <el-tab-pane
        label="批次"
        name="batch">
        <category-props
          ref="batch"
          type="batch"
          name="批次"
          :classId="current.classId"
          :templateType="2"
          :base="list.batchBaseTemplate"
          :extra="list.batchExtraTemplate"></category-props>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer">
      <el-button
        type="primary"
        @click="saveProps">保存</el-button>
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import CategoryProps from '@/components/business/industry/category-props.vue'
export default {
  name: 'CatePropModal',
  components: { CategoryProps },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      activeTab: 'product',
      current: {},
      list: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() { },
    getcategorytemplate(cb) {
      this.loading = true
      this.$store.dispatch('industry/getcategorytemplate', {
        payload: {
          classId: this.current.classId
        },
        success: (res) => {
          this.loading = false
          this.list = res.data
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(options) {
      this.current = options
      this.getcategorytemplate(() => {
        this.toggleModal(true)
      })
    },
    saveProps() {
      const refs = this.$refs
      const primiseArray = ['product', 'batch'].map(item => {
        return refs[item].validate()
      })
      Promise.all(primiseArray)
        .then(res => {
          const list = {}
          res.forEach(item => {
            list[item.type + 'BaseTemplate'] = item.baseTemplate
            list[item.type + 'ExtraTemplate'] = item.extraTemplate.map((item, index) => {
              item.sortNumber = index
              return item
            })
          })
          console.log(list)
          this.loading = true
          this.$store.dispatch('industry/updatecategorytemplate', {
            payload: {
              ...this.list,
              ...list
            },
            success: () => {
              this.loading = false
              // this.getcategorytemplate()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
        .catch(err => {
          console.log(err)
          this.$message.error(err.message)
          this.activeTab = err.type
        })
    }
  }
}
</script>
